import PropTypes from 'prop-types';

const LimitText = ({ text, limit }) => (
  <span title={text}>
    {(text || '').substring(0, limit)}
    {' '}
    {text && limit < text.length && <span>...</span>}
  </span>
);

LimitText.propTypes = {
  text: PropTypes.string.isRequired,
  limit: PropTypes.number,
};

LimitText.defaultProps = {
  limit: undefined,
};

export default LimitText;
